declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

//import { DBOperation } from '../../../../../enums/enum';
import { ActorEmploymentPreferencesRequest, ActorContactInfoRequest, EmergencyContactInfoRequest, SaveEmergencyContactInfoRequest } from '../../../../models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../services/hcp.service';


import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { ServiceConsultantMapController, ServiceDetailsByCodeController, ServiceDetailsByCodeRequest, ServiceBranchMapByServiceCodeController, ServiceBranchMapByServiceCodeRequest } from '../../../../models/actor/actor';
import { ServiceConsultantMapRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { CustomCodeTypeRequest_, CustomCodeValuesController_ } from '../../../../models/master/mastermodel';
import { FDService } from '../../../../services/fd.service';
import { ConsultantMapPipe } from '../../../../pipes/actors/actorIdentity.pipes';
import { parse } from 'querystring';

@Component({
  selector: 'ngbadddiscount',
    templateUrl: './adddiscount.modal.html',
    styleUrls: ['./adddiscount.modal.scss']
})

export class NgbAddDiscountModal implements OnInit {
  @ViewChild('f') IdentitiesForm: NgForm;
  @Input() ActorCode;
    @Input() IsShowDetail: boolean = false;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();
  //@Input() CurrentActorAddEmergencyInfoRequest: EmergencyContactInfoRequest;
  @Input() ServiceCode: number;
    searchTitle: string;
    @Input() PreviousDiscount: number;
    @Input() TodaysDiscount: number;
    public Remarks: string;
  public ApiResData: ApiResponseModel;
  public DiscountPercentOrFixedType: string;
  public DiscountPercent: number;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  //public IsSelected: boolean;
  CurrentActorAddEmergencyInfoRequest: SaveEmergencyContactInfoRequest;

  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService,
    private actorservice: ActorService, private fdservice: FDService, private filter: ConsultantMapPipe,
    private router: Router, private route: ActivatedRoute, private hcpservice: HCPService,
    private tosterservice: NGXToastrService) { }
  ngOnInit() {
    this.CurrentActorAddEmergencyInfoRequest = new SaveEmergencyContactInfoRequest();
    this.CurrentActorAddEmergencyInfoRequest.ConditionalOperator = 10;
    this.CurrentActorAddEmergencyInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorAddEmergencyInfoRequest.EmergencyContactCode = 0;
    this.CurrentActorAddEmergencyInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.ShowService = false;
    this.DiscountPercent = 0;

    this.LoadRegistries();


  }




  LoadRegistries() {
    this.StartRefreshing();



    //this.GetBranchMap();


  }
  public TotalDiscount: number;

  @Input() TotalBill: number;
    ChangeLFollicle() {
        //this.TotalDiscount = (this.PreviousDiscount) + (this.TodaysDiscount);
        this.TotalDiscount = +this.PreviousDiscount + this.TodaysDiscount;
    }


  DiscountTypeChange(e: any) {    
    if (this.DiscountPercentOrFixedType == 'Percentage (%)')
      this.ChangeDiscountPercentage(1);
    else
      this.ChangeLFollicle();
  }
  ChangeDiscountPercentage(n: number) {
    //alert(this.DiscountPercent);
    //alert(typeof this.DiscountPercent);
    if ((n == 1) && (typeof this.DiscountPercent === "number")) {
      // 
      if (this.DiscountPercent >= 0 && this.DiscountPercent <= 100) {
        this.ComputeDiscountTotalByPercentage();
      }
    }
  }
  ComputeDiscountTotalByPercentage() {
    //alert('calcl disc total...');
    this.TotalDiscount = ((this.TotalBill * this.DiscountPercent)/100);
    //this.TotalDiscount = +this.PreviousDiscount + this.TodaysDiscount;
  }
  onSubmit() {

    if (this.TotalDiscount <= this.TotalBill) {
      this.passEntry.emit({ make: this.TodaysDiscount, value: this.TotalDiscount, Remarks: this.Remarks });

      this.activeModal.dismiss('Cross click');
    }
    else {
      alertFunctions.AlertParam("Total Discount cannot be greater than Total Bill Amount");
      return;
      // cannot be greater 
    }


  }




  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }





}
